var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.$browser()) + " " + (_vm.finBrowser.IS_IOS_OR_ANDROID_APP?'app': 'web') + " " + (_vm.finBrowser.IS_IOS()?'ios': '') + " wrapper fin-app")},[_vm._t("default",function(){return [_c('router-view')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }